import { render, staticRenderFns } from "./ed-context-menu.vue?vue&type=template&id=0da20320&scoped=true&"
import script from "./ed-context-menu.ts?vue&type=script&lang=ts&"
export * from "./ed-context-menu.ts?vue&type=script&lang=ts&"
import style0 from "./ed-context-menu.scss?vue&type=style&index=0&id=0da20320&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0da20320",
  null
  
)

export default component.exports